
import {AbstractControl, ValidatorFn} from '@angular/forms';
import {IpGatewayValidatorService} from '../../order/services/ip-validator-gateway.service';


export function ipGatewayValidator(ipGatewayValidatorService: IpGatewayValidatorService): ValidatorFn {
  return (fg: AbstractControl) => {
    let validators = null;
    if (fg.value && fg.value.ip && fg.value.gateway && fg.value.mask && fg.value.dns1 && fg.value.dns2) {
      const ip = fg.get('ip').value;
      const gateway = fg.get('gateway').value;
      const mask = fg.get('mask').value;
      if (ipGatewayValidatorService.validateIPaddress(ip) &&
          ipGatewayValidatorService.validateIPaddress(mask) &&
          ipGatewayValidatorService.validateIPaddress(gateway)) {
        if (!ipGatewayValidatorService.validatorIp(fg.value)) {
          validators = {  errorAllow: true };
          fg.get('ip').setErrors({  errorAllow: true });
          fg.get('gateway').setErrors({  errorAllow: true  });
          fg.get('mask').setErrors({  errorAllow: true  });
        } else {
          validators = null;
          fg.get('ip').setErrors(null);
          fg.get('gateway').setErrors(null);
          fg.get('mask').setErrors(null);
        }
      }
    }
    return validators;
  };

}
